import { render } from "./PrimaryBtn.vue?vue&type=template&id=945aab42&scoped=true"
import script from "./PrimaryBtn.vue?vue&type=script&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&lang=js"

import "./PrimaryBtn.vue?vue&type=style&index=0&id=945aab42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-945aab42"

export default script